import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const ThickArrow: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M9.39 5.43312L5.39056 0.43381C5.20015 0.196543 4.79981 0.196543 4.60943 0.43381L0.609989 5.43312C0.348858 5.76007 0.582126 6.2455 1.00057 6.2455H2.50036V11.2449C2.50036 11.5213 2.72396 11.7449 3.00029 11.7449H6.99974C7.27606 11.7449 7.49967 11.5213 7.49967 11.2449V6.2455H8.99946C9.4179 6.2455 9.65113 5.76007 9.39 5.43312Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg {...props} width="10" height="12" viewBox="0 0 10 12" xmlns="http://www.w3.org/2000/svg">{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};